window.onload = function() {
  if(document.querySelector("#gi-pointify-input-point-container div div div.gi-pointify-label")){
    document.querySelector("#gi-pointify-input-point-container div div div.gi-pointify-label").innerText = 'ポイント利用';
  }
  if(document.querySelector("#gi-pointify-input-point-container div div div.gi-pointify-value span.gi-pointify-available-point")){
    let tmp = document.querySelector("#gi-pointify-input-point-container div div div.gi-pointify-value span.gi-pointify-available-point").innerText;
    document.querySelector("#gi-pointify-input-point-container div div div.gi-pointify-value span.gi-pointify-available-point").innerText = '（現在の所持ポイント：' + tmp.replace('ポイント','pt') + ' )';
  }
  if(document.querySelector("#gi-pointify-input-use-point")){
    document.querySelector("#gi-pointify-input-use-point").placeholder = '利用ポイントを入力してください';
  }
  if(document.querySelector("#gi-pointify-input-use-point")){
    document.querySelector("#gi-pointify-button-set-use-point").innerText = '利用する';
  }
}

// ブランドトップメインビジュアル
document.addEventListener('DOMContentLoaded', function () {
  if (typeof Swiper === 'undefined') return;

  document.querySelectorAll('.js-brand-kv-swiper').forEach(function (slider) {
    if (slider.classList.contains('is-initialized')) return;
    slider.classList.add('is-initialized');

    new Swiper(slider, {
      loop: true,
      slidesPerView: 'auto',
      centeredSlides: true,
      spaceBetween: 8,
      speed: 600,

      navigation: {
        nextEl: slider.querySelector('.brand-kv-swiper__arrow--next'),
        prevEl: slider.querySelector('.brand-kv-swiper__arrow--prev')
      },

      pagination: {
        el: slider.querySelector('.brand-kv-swiper__pagination'),
        clickable: true
      }
    });
  });
});

// ブランドトップ 商品スライダー（NEW ARRIVAL / GOODS など）
document.addEventListener('DOMContentLoaded', function () {
  if (typeof Swiper === 'undefined') return;

  document.querySelectorAll('.js-brand-product-swiper').forEach(function (slider) {
    if (slider.classList.contains('is-initialized')) return;

    slider.classList.add('is-initialized');

    const wrap = slider.closest('.brand-product-swiper-wrap');

    new Swiper(slider, {
      slidesPerView: 'auto',
      spaceBetween: 10,
      speed: 500,
      watchOverflow: true,

      navigation: {
        nextEl: wrap ? wrap.querySelector('.brand-product-swiper__arrow--next') : null,
        prevEl: wrap ? wrap.querySelector('.brand-product-swiper__arrow--prev') : null
      },

      breakpoints: {
        750: {
          spaceBetween: 20
        }
      }
    });
  });
});
// カラーバリエーション切り替え
document.addEventListener('click', function (e) {
  const thumb = e.target.closest('.js-product-thumb');
  if (!thumb) return;

  e.preventDefault();

  const card = thumb.closest('.brand-product-card');
  const img = card.querySelector('.js-product-image');
  const newImage = thumb.dataset.image;

  if (img && newImage) {
    img.style.opacity = '0.4';

    const preload = new Image();

    preload.onload = function () {
      img.src = newImage;

      requestAnimationFrame(function () {
        img.style.opacity = '1';
      });
    };

    preload.src = newImage;
  }

  card.querySelectorAll('.js-product-thumb').forEach(function (item) {
    item.classList.remove('is-active');
  });

  thumb.classList.add('is-active');
});
// ランキングカテゴリ切り替え
document.addEventListener('click', function(e){

  const tab = e.target.closest('.brand-ranking__tab');

  if(!tab) return;

  const wrap = tab.closest('.brand-ranking');

  const target = tab.dataset.rankingTab;

  wrap.querySelectorAll('.brand-ranking__tab').forEach(function(item){
    item.classList.remove('is-active');
  });

  wrap.querySelectorAll('.brand-ranking__panel').forEach(function(item){
    item.classList.remove('is-active');
  });

  tab.classList.add('is-active');

  const panel = wrap.querySelector('[data-ranking-panel="' + target + '"]');

  if(panel){
    panel.classList.add('is-active');
  }

});
// ブランドトップ NEWS
document.addEventListener('DOMContentLoaded', function () {
  if (typeof Swiper === 'undefined') return;

  document.querySelectorAll('.brand-news-slider-wrap').forEach((wrap) => {
    const swiperEl = wrap.querySelector('.js-brand-news-swiper');
    const prevEl = wrap.querySelector('.brand-news-swiper__prev');
    const nextEl = wrap.querySelector('.brand-news-swiper__next');

    if (!swiperEl) return;

    new Swiper(swiperEl, {
      slidesPerView: 2,
      spaceBetween: 20,
      loop: false,
      watchOverflow: true,
      navigation: {
        prevEl,
        nextEl,
      },
      breakpoints: {
        750: {
          slidesPerView: 4,
          spaceBetween: 20,
        },
      },
    });
  });
});

// ブランドトップ NEWSタブ切り替え
document.addEventListener('click', function (e) {
  const tab = e.target.closest('.brand-news__tab');
  if (!tab) return;

  const wrap = tab.closest('.brand-news');
  const target = tab.dataset.brandNewsTab;

  wrap.querySelectorAll('.brand-news__tab').forEach(function (item) {
    item.classList.remove('is-active');
  });

  wrap.querySelectorAll('.brand-news__panel').forEach(function (item) {
    item.classList.remove('is-active');
  });

  tab.classList.add('is-active');

  const panel = wrap.querySelector('[data-brand-news-panel="' + target + '"]');

  if (panel) {
    panel.classList.add('is-active');

    panel.querySelectorAll('.js-brand-news-swiper').forEach(function (slider) {
      if (slider.swiper) {
        slider.swiper.update();
      }
    });
  }
});

// ブランドトップ LIVE（SPのみSwiper）
document.addEventListener('DOMContentLoaded', function () {
  if (typeof Swiper === 'undefined') return;

  document.querySelectorAll('.js-brand-live-swiper').forEach(function (slider) {
    if (slider.classList.contains('is-initialized')) return;
    slider.classList.add('is-initialized');

    const wrap = slider.closest('.brand-live-slider-wrap');

    new Swiper(slider, {
      slidesPerView: 1,
      centeredSlides: true,
      spaceBetween: 12,
      speed: 500,
      watchOverflow: true,
      navigation: {
        nextEl: wrap ? wrap.querySelector('.brand-live__arrow--next') : null,
        prevEl: wrap ? wrap.querySelector('.brand-live__arrow--prev') : null
      },
      breakpoints: {
        750: {
          enabled: false
        }
      }
    });
  });
});

// 商品カード：カラーバリエーション
document.addEventListener('DOMContentLoaded', function () {
  function initProductCardColorThumbs(scope) {
    const productCards = scope.querySelectorAll('[data-new-arrival-card]');

    productCards.forEach(function (card) {
      if (card.dataset.colorThumbInitialized === 'true') return;

      const mainImage = card.querySelector('[data-new-arrival-main-image]');
      const thumbs = card.querySelectorAll('[data-new-arrival-color-thumb]');

      if (!mainImage || !thumbs.length) return;

      card.dataset.colorThumbInitialized = 'true';

      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function (e) {
          e.preventDefault();

          const imageSrc = thumb.dataset.imageSrc;
          const imageSrcset = thumb.dataset.imageSrcset;

          if (!imageSrc) return;

          mainImage.src = imageSrc;

          if (imageSrcset) {
            mainImage.srcset = imageSrcset;
          } else {
            mainImage.removeAttribute('srcset');
          }

          thumbs.forEach(function (item) {
            item.classList.remove('is-active');
          });

          thumb.classList.add('is-active');
        });
      });
    });
  }

  initProductCardColorThumbs(document);

  const observer = new MutationObserver(function () {
    initProductCardColorThumbs(document);
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});

const brandHeader = document.querySelector('.header--brand');

if (brandHeader) {
  const toggleBrandHeader = () => {
    brandHeader.classList.toggle('is-compact', window.scrollY > 0);
  };

  toggleBrandHeader();
  window.addEventListener('scroll', toggleBrandHeader, { passive: true });
}

// ========================================
// Staff Start：ブランド状態の引き継ぎ
// ========================================
document.addEventListener('DOMContentLoaded', function () {
  const STAFFSTART_PATH_PATTERN = /^\/apps\/staffstart\/(?:coordinates|staffs)(?:\/|$)/;

  if (!STAFFSTART_PATH_PATTERN.test(window.location.pathname)) {
    return;
  }

  const BRAND_STORAGE_KEY = 'mindwindStaffstartBrand';

  const brandAliases = {
    sabstreet: 'sabstreet',
    sabstreetbis: 'sabstreetbis',
    bis: 'sabstreetbis',
    jetsetsoloplus: 'jetsetsoloplus',
    jetset: 'jetsetsoloplus'
  };

  const params = new URLSearchParams(window.location.search);
  const label = params.get('label');
  const storedBrand = window.sessionStorage.getItem(BRAND_STORAGE_KEY);

  let currentBrand = '';

  if (label && brandAliases[label]) {
    currentBrand = brandAliases[label];
  } else if (storedBrand && brandAliases[storedBrand]) {
    currentBrand = brandAliases[storedBrand];
  }

  // ブランドがまったく判定できない場合のみsabstreetを初期値にする
  if (!currentBrand) {
    currentBrand = 'sabstreet';
  }

  window.sessionStorage.setItem(BRAND_STORAGE_KEY, currentBrand);

  document.documentElement.dataset.staffstartBrand = currentBrand;

  function initStaffstartBrandHeader() {
    const headerMount = document.querySelector(
      '[data-staffstart-brand-header]'
    );

    const headerTemplate = document.querySelector(
      '[data-staffstart-header-template="' + currentBrand + '"]'
    );

    if (!headerMount || !headerTemplate) {
      return;
    }

    if (headerMount.dataset.initialized === 'true') {
      return;
    }

    headerMount.appendChild(
      headerTemplate.content.cloneNode(true)
    );

    headerMount.hidden = false;
    headerMount.dataset.initialized = 'true';

    const defaultHeader = document.querySelector(
      '.header--staffstart-default'
    );

    if (defaultHeader) {
      const headerBrandClassMap = {
        sabstreet: 'header--sabstreet',
        sabstreetbis: 'header--bis',
        jetsetsoloplus: 'header--jetset'
      };

      defaultHeader.hidden = false;
      defaultHeader.removeAttribute('hidden');
      defaultHeader.classList.add('header--brand');

      Object.values(headerBrandClassMap).forEach(function (className) {
        defaultHeader.classList.remove(className);
      });

      if (headerBrandClassMap[currentBrand]) {
        defaultHeader.classList.add(
          headerBrandClassMap[currentBrand]
        );
      }
    }
  }

  function appendBrandLabelToStaffstartLinks(scope) {
    const links = scope.querySelectorAll(
      'a[href*="/apps/staffstart/coordinates"],' +
      'a[href*="/apps/staffstart/staffs"]'
    );

    links.forEach(function (link) {
      if (link.dataset.staffstartBrandLinked === 'true') {
        return;
      }

      let url;

      try {
        url = new URL(link.href, window.location.origin);
      } catch (error) {
        return;
      }

      if (url.origin !== window.location.origin) {
        return;
      }

      if (!STAFFSTART_PATH_PATTERN.test(url.pathname)) {
        return;
      }

      url.searchParams.set('label', currentBrand);

      link.href =
        url.pathname +
        url.search +
        url.hash;

      link.dataset.staffstartBrandLinked = 'true';
    });
  }

  initStaffstartBrandHeader();
  appendBrandLabelToStaffstartLinks(document);

  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (!(node instanceof HTMLElement)) {
          return;
        }

        if (node.matches('a')) {
          appendBrandLabelToStaffstartLinks(node.parentElement || node);
        } else {
          appendBrandLabelToStaffstartLinks(node);
        }
      });
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});


// 260711 FAQ改修 weblab
document.addEventListener('DOMContentLoaded', function () {
  if (!/\/pages\/faq\/?$/.test(window.location.pathname)) return;

  var headings = Array.prototype.slice.call(
    document.querySelectorAll('.collapsible-content__heading')
  );
  if (!headings.length) return;

  document.body.classList.add('faq-page');

  var categories = [];
  headings.forEach(function (heading, i) {
    var section = heading.closest('.shopify-section') || heading.closest('.collapsible-content');
    var name = (heading.textContent || '').trim();
    if (!section || !name) return;
    section.id = section.id || 'faq-cat-' + i;
    section.classList.add('faq-cat');
    categories.push({ name: name, section: section, heading: heading });
  });
  if (!categories.length) return;

  // カテゴリピル
  var nav = document.createElement('nav');
  nav.className = 'faq-catnav';
  nav.setAttribute('aria-label', 'よくあるご質問カテゴリ');

  var list = document.createElement('ul');
  list.className = 'faq-catnav__list';

  categories.forEach(function (cat) {
    var item = document.createElement('li');
    item.className = 'faq-catnav__item';

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'faq-catnav__btn';
    btn.textContent = cat.name;
    btn.addEventListener('click', function () {
      cat.section.classList.remove('faq-cat--closed'); // 折りたたみ済みなら開く
      var top = cat.section.getBoundingClientRect().top + window.pageYOffset - 90;
      window.scrollTo({ top: top, behavior: 'smooth' });
    });

    item.appendChild(btn);
    list.appendChild(item);
  });

  nav.appendChild(list);

  var firstSection = categories[0].section;
  firstSection.parentNode.insertBefore(nav, firstSection);

  // カテゴリ見出しクリックで開閉
  categories.forEach(function (cat) {
    cat.heading.classList.add('faq-cat__heading');
    cat.heading.setAttribute('role', 'button');
    cat.heading.setAttribute('tabindex', '0');
    cat.heading.setAttribute('aria-expanded', 'true');

    var toggle = function () {
      var closed = cat.section.classList.toggle('faq-cat--closed');
      cat.heading.setAttribute('aria-expanded', closed ? 'false' : 'true');
    };

    cat.heading.addEventListener('click', toggle);
    cat.heading.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        toggle();
      }
    });
  });
});

// 260711 カート改修 weblab
document.addEventListener('DOMContentLoaded', function () {
  if (!/^\/cart\/?$/.test(window.location.pathname)) return;
  document.body.classList.add('cart-page');

  // 備考欄ラベルを新デザイン文言に（プレースホルダは消す）
  var noteLabel = document.querySelector('.cart__note > label');
  if (noteLabel) noteLabel.textContent = '注文に関するご要望など';
  var noteArea = document.querySelector('.cart__note textarea');
  if (noteArea) noteArea.setAttribute('placeholder', '');

  // 会員ボックス文言
  var loginTitle = document.querySelector('.cart__login-title');
  if (loginTitle) loginTitle.textContent = '会員登録はお済みですか？';
  var loginPara = document.querySelector('.cart__login-paragraph');
  if (loginPara) {
    var loginLink = loginPara.querySelector('a');
    var href = loginLink ? loginLink.getAttribute('href') : '/account/login';
    loginPara.innerHTML = '<a href="' + href + '">ログイン</a>することで便利にお買い物をしていただけます';
  }

  // shopボタンを購入手続き直下・「買い物を続ける」をその下へ移動
  var cont = document.getElementById('continue-shopping');
  var ctas = document.querySelector('.cart__ctas');
  var dynCheckout = document.querySelector('.cart__dynamic-checkout-buttons');
  if (cont && ctas && ctas.parentNode) {
    var wrap = document.createElement('div');
    wrap.className = 'cart__continue-wrap';
    wrap.appendChild(cont);
    var anchor = dynCheckout || ctas; // shopボタンがあればその後ろ、無ければ購入手続きの後ろ
    anchor.parentNode.insertBefore(wrap, anchor.nextSibling);
  }
  // shopボタンの幅を購入手続きボタンに合わせる
  var checkoutBtn = document.querySelector('.cart__checkout-button');
  if (checkoutBtn && dynCheckout) {
    var syncShopWidth = function () { var w = checkoutBtn.offsetWidth; if (w) dynCheckout.style.width = w + 'px'; };
    syncShopWidth();
    window.addEventListener('resize', syncShopWidth);
    new MutationObserver(syncShopWidth).observe(dynCheckout, { childList: true, subtree: true });
  }

  // 空カート文言：先頭「※」・文末「。」を削除
  var emptyText = document.querySelector('.cart__empty-text');
  if (emptyText) emptyText.textContent = (emptyText.textContent || '').replace(/^※/, '').replace(/。$/, '').trim();

  // 会員ボックスを枠線で囲む（見出し＋段落をラップ）
  if (loginTitle && loginPara && !document.querySelector('.mw-cart-login-box')) {
    var box = document.createElement('div');
    box.className = 'mw-cart-login-box';
    loginTitle.parentNode.insertBefore(box, loginTitle);
    box.appendChild(loginTitle);
    box.appendChild(loginPara);
  }

  // 送料無料バー（Mattrz遅延注入）：文言整形
  var fixFsBar = function () {
    var nc = document.querySelector('[id$="_fs_no_charge"]');
    if (!nc) return false;
    var span = nc.querySelector('[id$="_fs_free_shipping"]');
    if (!span) return false;
    // 既に整形済みなら何もしない（Mattrz再描画時のループ防止）
    if (nc.firstChild && nc.firstChild.nodeValue === 'あと ' &&
        span.nextSibling && span.nextSibling.nodeValue === ' で送料無料です') return true;
    var brs = nc.querySelectorAll('br');
    for (var i = 0; i < brs.length; i++) brs[i].remove();
    var kids = Array.prototype.slice.call(nc.childNodes);
    for (var j = 0; j < kids.length; j++) {
      if (kids[j].nodeType === 3) nc.removeChild(kids[j]);
    }
    nc.insertBefore(document.createTextNode('あと '), span);
    if (span.nextSibling) nc.insertBefore(document.createTextNode(' で送料無料です'), span.nextSibling);
    else nc.appendChild(document.createTextNode(' で送料無料です'));
    return true;
  };
  fixFsBar();
  // Mattrzの遅延注入・金額更新に追従（整形済みは再処理しない）
  var fsObs = new MutationObserver(function () { fixFsBar(); });
  fsObs.observe(document.body, { childList: true, subtree: true });
  setTimeout(function () { fsObs.disconnect(); }, 30000);

  // 合計/数量セルをPCで table-cell 化（アプリのblockification対策・SPは触らない）
  var cartCellFix = function () {
    var desktop = window.matchMedia('(min-width: 750px)').matches;
    // ヘッダーの「合計」th も同じ対象に含める
    var cells = document.querySelectorAll('.cart-item__totals.small-hide, .cart-item__quantity, .cart-items thead th.small-hide');
    for (var i = 0; i < cells.length; i++) {
      if (desktop) {
        // float/absolute を打ち消してから table-cell 化（blockification回避）
        cells[i].style.setProperty('float', 'none', 'important');
        cells[i].style.setProperty('position', 'relative', 'important');
        cells[i].style.setProperty('display', 'table-cell', 'important');
        cells[i].style.setProperty('vertical-align', 'middle', 'important');
      } else {
        cells[i].style.removeProperty('float');
        cells[i].style.removeProperty('position');
        cells[i].style.removeProperty('display');
        cells[i].style.removeProperty('vertical-align');
      }
    }
  };
  cartCellFix();
  window.addEventListener('resize', cartCellFix);
  // 起動直後のアプリ(Mattrz等)非同期描画に追従して貼り直す（約4秒バースト）
  var _burst = 0;
  var _burstTimer = setInterval(function () { cartCellFix(); if (++_burst > 40) clearInterval(_burstTimer); }, 100);
  // 以降のカート再描画にも追従（安定祖先を監視して貼り直す）
  var cartWatch = document.getElementById('MainContent') || document.body;
  new MutationObserver(function () { cartCellFix(); }).observe(cartWatch, { childList: true, subtree: true });
});

// 260711 ログイン改修 weblab（260712 デザイン全面反映）
document.addEventListener('DOMContentLoaded', function () {
  if (!/^\/account\/login\/?$/.test(window.location.pathname)) return;
  document.body.classList.add('login-page');

  // アイコン（weblab支給SVG）
  var ICON_LOGIN = '<svg class="mw-ico" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.4595 12.75H2.51953V11.25H12.4595L10.3895 9.18L11.4495 8.12L15.3295 12L11.4495 15.88L10.3895 14.82L12.4595 12.75ZM5.51953 1.75V7.75H7.01953V3.25H19.9695V20.75H7.01953V16.25H5.51953V22.25H21.4695V1.75H5.51953Z" fill="currentColor"/></svg>';
  var ICON_SHIELD = '<svg class="mw-ico" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 4.78965L3.75 0.389648V16.9996L12 23.5996L20.25 16.9996V0.389648L12 4.78965ZM5.25 2.88965L11.25 6.08965V21.0796L5.25 16.2796V2.88965ZM18.75 16.2796L12.75 21.0796V6.08965L18.75 2.88965V16.2796Z" fill="currentColor"/></svg>';
  // ポイントカードのアイコン（weblab支給SVG）
  var ICON_JACKET = '<svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M39.3606 9.80977L34.3356 7.10977L30.1956 4.37977C30.1806 4.36477 30.1956 4.36477 30.1506 4.34977C30.1206 4.33477 30.0756 4.30477 30.0006 4.28977C29.9706 4.28977 29.9406 4.27477 29.8956 4.25977H29.8056H18.1806C18.1806 4.25977 18.0606 4.27477 18.0456 4.27477C18.0306 4.27477 17.9256 4.31977 17.9106 4.33477C17.9106 4.33477 17.8656 4.36477 17.8506 4.36477L13.6956 7.10977L8.64062 9.82477C7.26063 10.5748 6.39062 12.0148 6.39062 13.5748V40.7098C6.39062 41.0698 6.67562 41.3548 7.03562 41.3548H11.6556C11.8506 42.7348 13.0206 43.7698 14.4456 43.7698H33.5706C34.9806 43.7698 36.1656 42.7198 36.3606 41.3548H40.9806C41.3406 41.3548 41.6256 41.0698 41.6256 40.7098V13.5598C41.6256 11.9848 40.7706 10.5448 39.3756 9.80977H39.3606ZM40.3056 13.5598V40.0498H35.8806V24.2698L39.6756 11.7298C40.0806 12.2548 40.3056 12.8998 40.3056 13.5598ZM34.4556 19.6198C34.6956 19.3798 34.6956 18.9748 34.4556 18.7198L32.0406 16.1248L34.4256 13.7998C34.5456 13.6798 34.6206 13.5148 34.6206 13.3348V8.72977L38.5656 10.8598L34.6056 23.9848C34.6056 23.9848 34.5756 24.1048 34.5756 24.1648V33.8398H28.2456C27.8856 33.8398 27.6006 34.1248 27.6006 34.4848V38.9848C27.6006 39.3448 27.8856 39.6298 28.2456 39.6298H34.5756V40.6798C34.5756 40.9648 34.7556 41.2048 35.0106 41.2948C34.8456 41.9548 34.2456 42.4498 33.5406 42.4498H26.0706V30.8398C26.0706 30.8398 26.0706 30.7798 26.0706 30.7498C26.0706 30.7498 26.0706 30.6898 26.0706 30.6748L25.5306 28.7248L34.4556 19.5748V19.6198ZM28.9206 38.3548V35.1598H34.5906V38.3548H28.9206ZM33.3456 13.0648L30.7056 15.6448C30.4506 15.8848 30.4506 16.2898 30.6906 16.5448L33.1056 19.1548L25.1406 27.3148L24.6906 25.6798L30.1956 5.90977L33.3606 7.99477V13.0498L33.3456 13.0648ZM24.1506 28.6198L14.9106 19.1548L17.3256 16.5598C17.5656 16.3048 17.5656 15.8998 17.3106 15.6598L14.6706 13.0798V8.02477L17.8356 5.93977L23.3856 25.8448C23.3856 25.8448 23.4006 25.9048 23.4006 25.9198L24.1656 28.6348L24.1506 28.6198ZM19.0506 5.53477H28.9356L23.9856 23.2798L19.0356 5.53477H19.0506ZM19.0806 35.1448V38.3398H13.4106V35.1448H19.0806ZM13.4106 40.6948V39.6448H19.7256C20.0856 39.6448 20.3706 39.3598 20.3706 38.9998V34.4998C20.3706 34.1398 20.0856 33.8548 19.7256 33.8548H13.4106V24.1798C13.4106 24.1798 13.4106 24.0598 13.3806 23.9998L9.42062 10.8748L13.3656 8.74477V13.3498C13.3656 13.5298 13.4406 13.6948 13.5606 13.8148L15.9456 16.1398L13.5306 18.7348C13.2906 18.9898 13.3056 19.3798 13.5306 19.6348L24.7806 31.1698V42.4948H14.4306C13.7256 42.4948 13.1256 41.9998 12.9606 41.3398C13.2156 41.2498 13.3956 41.0098 13.3956 40.7248L13.4106 40.6948ZM12.1206 24.2698V40.0498H7.69562V13.5598C7.69562 12.8998 7.92062 12.2398 8.32562 11.7298L12.1206 24.2698Z" fill="currentColor"/></svg>';
  var ICON_POINT = '<svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M22.9642 34.0655C20.9992 36.0305 18.3742 37.1255 15.5842 37.1255C12.7942 37.1255 10.1842 36.0455 8.20422 34.0655C5.38422 31.2455 4.42422 27.1355 5.69922 23.3555C5.81922 23.0105 6.20922 22.8155 6.55422 22.9355C6.91422 23.0555 7.09422 23.4305 6.97422 23.7905C5.86422 27.0905 6.70422 30.6605 9.16422 33.1205C10.8742 34.8305 13.1542 35.7755 15.5842 35.7755C18.0142 35.7755 20.2942 34.8305 22.0042 33.1205C23.7142 31.4105 24.6592 29.1305 24.6592 26.7005C24.6592 24.2705 23.7142 21.9905 22.0042 20.2805C19.5442 17.8205 15.9742 16.9805 12.6742 18.0905C12.3142 18.2105 11.9392 18.0155 11.8192 17.6705C11.6992 17.3105 11.8942 16.9355 12.2392 16.8155C16.0192 15.5405 20.1292 16.5005 22.9492 19.3205C24.9142 21.2855 26.0092 23.9105 26.0092 26.7005C26.0092 29.4905 24.9292 32.1005 22.9492 34.0805L22.9642 34.0655ZM42.3292 15.4505V20.2505H44.9992C45.3742 20.2505 45.6742 20.5505 45.6742 20.9255V27.0755C45.6742 27.4505 45.3742 27.7505 44.9992 27.7505H42.3292V32.5505H44.9992C45.3742 32.5505 45.6742 32.8505 45.6742 33.2255V39.3755C45.6742 39.7505 45.3742 40.0505 44.9992 40.0505H16.0942C16.0942 40.0505 16.0342 40.0505 16.0042 40.0355C15.8842 40.0355 15.7642 40.0505 15.6292 40.0505C8.29422 40.0505 2.32422 34.0805 2.32422 26.7455C2.32422 19.4105 8.29422 13.4405 15.6292 13.4405C16.7242 13.4405 17.7892 13.5905 18.8092 13.8455V8.65547C18.8092 8.28047 19.1092 7.98047 19.4842 7.98047H44.9842C45.3592 7.98047 45.6592 8.28047 45.6592 8.65547V14.8055C45.6592 15.1805 45.3592 15.4805 44.9842 15.4805H42.3142L42.3292 15.4505ZM20.1742 14.1005H44.3242V9.30047H20.1742V14.1005ZM15.6292 38.6855C22.2292 38.6855 27.5842 33.3155 27.5842 26.7305C27.5842 21.5255 24.2242 17.0855 19.5742 15.4505H19.4842C19.3042 15.4505 19.1542 15.3755 19.0342 15.2705C17.9542 14.9555 16.8142 14.7755 15.6292 14.7755C9.02922 14.7755 3.67422 20.1455 3.67422 26.7305C3.67422 33.3155 9.04422 38.6855 15.6292 38.6855ZM44.3242 33.9005H26.8342C25.5142 35.9555 23.6542 37.6205 21.4342 38.7005H44.3242V33.9005ZM40.9792 27.7505H28.8892C28.7542 29.4605 28.3042 31.0805 27.5842 32.5505H40.9792V27.7505ZM44.3242 21.6005H27.9142C28.5292 23.0855 28.8892 24.7055 28.9342 26.4005H44.3392V21.6005H44.3242ZM40.9792 15.4505H22.6642C24.5692 16.6355 26.1442 18.2855 27.2392 20.2505H40.9642V15.4505H40.9792ZM12.5242 32.5055C12.1492 32.5055 11.8492 32.2055 11.8492 31.8305V22.1405C11.8492 21.7655 12.1492 21.4655 12.5242 21.4655H17.0392C19.0192 21.4655 20.6242 23.0705 20.6242 25.0505C20.6242 27.0305 19.0192 28.6355 17.0392 28.6355H13.1992V31.8305C13.1992 32.2055 12.8992 32.5055 12.5242 32.5055ZM13.1992 27.2855H17.0392C18.2692 27.2855 19.2742 26.2805 19.2742 25.0505C19.2742 23.8205 18.2692 22.8155 17.0392 22.8155H13.1992V27.2855Z" fill="currentColor"/></svg>';
  var ICON_COUPON = '<svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M34.0492 24.6752C34.3192 24.9452 34.3192 25.3652 34.0492 25.6352C33.9142 25.7702 33.7492 25.8302 33.5692 25.8302C33.3892 25.8302 33.2242 25.7702 33.0892 25.6352L32.6092 25.1552C32.3392 24.8852 32.3392 24.4652 32.6092 24.1952C32.8792 23.9252 33.2992 23.9252 33.5692 24.1952L34.0492 24.6752ZM25.6342 16.2602C25.3642 15.9902 24.9442 15.9902 24.6742 16.2602C24.4042 16.5302 24.4042 16.9502 24.6742 17.2202L25.4992 18.0452C25.6342 18.1802 25.7992 18.2402 25.9792 18.2402C26.1592 18.2402 26.3242 18.1802 26.4592 18.0452C26.7292 17.7752 26.7292 17.3552 26.4592 17.0852L25.6342 16.2602ZM28.2742 18.9002C28.0042 18.6302 27.5842 18.6302 27.3142 18.9002C27.0442 19.1702 27.0442 19.5902 27.3142 19.8602L28.1392 20.6852C28.2742 20.8202 28.4392 20.8802 28.6192 20.8802C28.7992 20.8802 28.9642 20.8202 29.0992 20.6852C29.3692 20.4152 29.3692 19.9952 29.0992 19.7252L28.2742 18.9002ZM30.9292 21.5402C30.6592 21.2702 30.2392 21.2702 29.9692 21.5402C29.6992 21.8102 29.6992 22.2302 29.9692 22.5002L30.7942 23.3252C30.9292 23.4602 31.0942 23.5202 31.2742 23.5202C31.4542 23.5202 31.6192 23.4602 31.7542 23.3252C32.0242 23.0552 32.0242 22.6352 31.7542 22.3652L30.9292 21.5402ZM22.8592 15.3902C22.9942 15.5252 23.1592 15.5852 23.3392 15.5852C23.5192 15.5852 23.6842 15.5252 23.8192 15.3902C24.0892 15.1202 24.0892 14.7002 23.8192 14.4302L23.3392 13.9502C23.0692 13.6802 22.6492 13.6802 22.3792 13.9502C22.1092 14.2202 22.1092 14.6402 22.3792 14.9102L22.8592 15.3902ZM27.9742 14.1902C27.7042 14.4602 27.7042 14.8802 27.9742 15.1502C28.1092 15.2852 28.2742 15.3452 28.4542 15.3452C28.6342 15.3452 28.7992 15.2852 28.9342 15.1502L31.8592 12.2252C32.1292 11.9552 32.1292 11.5352 31.8592 11.2652C31.5892 10.9952 31.1692 10.9952 30.8992 11.2652L27.9742 14.1902ZM30.4192 17.5802C30.5542 17.7152 30.7192 17.7752 30.8992 17.7752C31.0792 17.7752 31.2442 17.7152 31.3792 17.5802L34.3042 14.6552C34.5742 14.3852 34.5742 13.9652 34.3042 13.6952C34.0342 13.4252 33.6142 13.4252 33.3442 13.6952L30.4192 16.6202C30.1492 16.8902 30.1492 17.3102 30.4192 17.5802ZM35.7742 16.1402L32.8492 19.0652C32.5792 19.3352 32.5792 19.7552 32.8492 20.0252C32.9842 20.1602 33.1492 20.2202 33.3292 20.2202C33.5092 20.2202 33.6742 20.1602 33.8092 20.0252L36.7342 17.1002C37.0042 16.8302 37.0042 16.4102 36.7342 16.1402C36.4642 15.8702 36.0442 15.8702 35.7742 16.1402ZM29.6692 7.3052C29.8492 7.3052 30.0142 7.2452 30.1492 7.1102L31.1242 6.1352C31.3942 5.8652 31.3942 5.4452 31.1242 5.1752C30.8542 4.9052 30.4342 4.9052 30.1642 5.1752L29.1892 6.1502C28.9192 6.4202 28.9192 6.8402 29.1892 7.1102C29.3242 7.2452 29.4892 7.3052 29.6692 7.3052ZM27.6592 9.6002L28.6342 8.6252C28.9042 8.3552 28.9042 7.9352 28.6342 7.6652C28.3642 7.3952 27.9442 7.3952 27.6742 7.6652L26.6992 8.6402C26.4292 8.9102 26.4292 9.3302 26.6992 9.6002C26.8342 9.7352 26.9992 9.7952 27.1792 9.7952C27.3592 9.7952 27.5242 9.7352 27.6592 9.6002ZM46.4242 17.8352C46.4242 18.0152 46.3492 18.1802 46.2292 18.3152L37.4542 27.0902C37.1992 27.3452 36.7492 27.3452 36.4942 27.0902C36.2242 26.8202 35.7592 26.8202 35.5042 27.0902C35.3692 27.2252 35.2942 27.4052 35.2942 27.5852C35.2942 27.7652 35.3692 27.9452 35.5042 28.0802C35.6392 28.2152 35.6992 28.3802 35.6992 28.5602C35.6992 28.7402 35.6242 28.9052 35.5042 29.0402L18.3142 46.2302C18.1942 46.3502 18.0142 46.4252 17.8342 46.4252C17.6542 46.4252 17.4892 46.3502 17.3542 46.2302L11.9992 40.8752C11.7292 40.6052 11.7292 40.1852 11.9992 39.9152C13.0792 38.8352 13.0792 37.0802 11.9992 36.0002C10.9192 34.9202 9.16422 34.9202 8.08422 36.0002C7.81422 36.2702 7.39422 36.2702 7.12422 36.0002L1.76922 30.6452C1.64922 30.5252 1.57422 30.3452 1.57422 30.1652C1.57422 29.9852 1.64922 29.8202 1.76922 29.6852L18.9592 12.4952C19.0792 12.3752 19.2592 12.3002 19.4392 12.3002C19.6192 12.3002 19.7842 12.3752 19.9192 12.4952C20.1892 12.7652 20.6542 12.7652 20.9092 12.4952C21.0442 12.3602 21.1192 12.1802 21.1192 12.0002C21.1192 11.8202 21.0442 11.6402 20.9092 11.5052C20.7892 11.3852 20.7142 11.2052 20.7142 11.0252C20.7142 10.8452 20.7892 10.6802 20.9092 10.5452L29.6842 1.7702C29.8042 1.6502 29.9842 1.5752 30.1642 1.5752C30.3442 1.5752 30.5092 1.6502 30.6442 1.7702L35.9992 7.1252C36.2692 7.3952 36.2692 7.8152 35.9992 8.0852C34.9192 9.1652 34.9192 10.9202 35.9992 12.0002C37.0792 13.0802 38.8342 13.0802 39.9142 12.0002C40.1842 11.7302 40.6042 11.7302 40.8742 12.0002L46.2292 17.3552C46.3492 17.4752 46.4242 17.6552 46.4242 17.8352ZM44.7892 17.8352L40.3492 13.3952C38.7442 14.5502 36.4792 14.4002 35.0392 12.9602C33.5992 11.5202 33.4492 9.2552 34.6042 7.6502L30.1642 3.2102L22.2742 11.1002C22.4092 11.3702 22.4842 11.6852 22.4842 12.0002C22.4842 12.5552 22.2742 13.0652 21.8842 13.4552C21.2692 14.0702 20.2942 14.2202 19.5442 13.8452L3.22422 30.1652L7.66422 34.6052C9.26922 33.4502 11.5342 33.6002 12.9742 35.0402C14.4142 36.4802 14.5642 38.7452 13.4092 40.3502L17.8492 44.7902L34.1692 28.4702C34.0342 28.2002 33.9592 27.8852 33.9592 27.5702C33.9592 27.0152 34.1692 26.5052 34.5592 26.1152C35.1742 25.5002 36.1492 25.3502 36.8992 25.7252L41.8642 20.7602L44.8042 17.8202L44.7892 17.8352ZM26.4292 29.8502C26.5342 30.0302 26.5642 30.2402 26.5042 30.4352C26.4292 30.6302 26.2792 30.7802 26.0842 30.8552L23.4892 31.7402L22.6042 34.3352C22.5442 34.5302 22.3792 34.6802 22.1842 34.7552C22.1092 34.7852 22.0342 34.8002 21.9592 34.8002C21.8392 34.8002 21.7042 34.7702 21.5992 34.6952L19.2892 33.2102L16.7092 34.1402C16.5142 34.2152 16.3042 34.1852 16.1242 34.0802C15.9442 33.9752 15.8392 33.7802 15.8092 33.5852L15.5242 30.8552L13.1842 29.4152C13.0042 29.3102 12.8842 29.1152 12.8692 28.9202C12.8542 28.7252 12.9142 28.5152 13.0642 28.3652L15.0142 26.4452L14.6842 23.7152C14.6542 23.5052 14.7292 23.3102 14.8792 23.1602C15.0292 23.0102 15.2242 22.9502 15.4342 22.9652L18.1642 23.2952L20.0842 21.3452C20.2342 21.1952 20.4292 21.1202 20.6392 21.1502C20.8492 21.1802 21.0292 21.2852 21.1342 21.4652L22.5742 23.8052L25.3042 24.0902C25.5142 24.1052 25.6942 24.2252 25.7992 24.4052C25.9042 24.5852 25.9342 24.7952 25.8592 24.9902L24.9292 27.5702L26.4142 29.8802L26.4292 29.8502ZM24.8242 29.8502L23.6242 27.9752C23.5192 27.7952 23.4892 27.5852 23.5642 27.3902L24.3142 25.3052L22.1092 25.0802C21.8992 25.0652 21.7192 24.9452 21.5992 24.7652L20.4292 22.8752L18.8692 24.4502C18.7192 24.6002 18.5092 24.6752 18.3142 24.6452L16.1092 24.3752L16.3792 26.5802C16.4092 26.7902 16.3342 27.0002 16.1842 27.1352L14.6092 28.6952L16.4992 29.8652C16.6792 29.9702 16.7992 30.1652 16.8142 30.3752L17.0392 32.5802L19.1242 31.8302C19.1242 31.8302 19.2742 31.7852 19.3492 31.7852C19.4692 31.7852 19.6042 31.8152 19.7092 31.8902L21.5842 33.0902L22.3042 30.9902C22.3642 30.7952 22.5292 30.6302 22.7242 30.5702L24.8242 29.8502Z" fill="currentColor"/></svg>';
  var ICON_CART = '<svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14.5057 38.1155C12.6157 38.1155 11.0857 39.6455 11.0857 41.5355C11.0857 43.4255 12.6157 44.9555 14.5057 44.9555C16.3957 44.9555 17.9257 43.4255 17.9257 41.5355C17.9257 39.6455 16.3957 38.1155 14.5057 38.1155ZM14.5057 43.5905C13.3657 43.5905 12.4357 42.6605 12.4357 41.5205C12.4357 40.3805 13.3657 39.4505 14.5057 39.4505C15.6457 39.4505 16.5757 40.3805 16.5757 41.5205C16.5757 42.6605 15.6457 43.5905 14.5057 43.5905ZM28.6057 38.1155C26.7157 38.1155 25.1857 39.6455 25.1857 41.5355C25.1857 43.4255 26.7157 44.9555 28.6057 44.9555C30.4957 44.9555 32.0257 43.4255 32.0257 41.5355C32.0257 39.6455 30.4957 38.1155 28.6057 38.1155ZM28.6057 43.5905C27.4657 43.5905 26.5357 42.6605 26.5357 41.5205C26.5357 40.3805 27.4657 39.4505 28.6057 39.4505C29.7457 39.4505 30.6757 40.3805 30.6757 41.5205C30.6757 42.6605 29.7457 43.5905 28.6057 43.5905ZM45.7807 16.1855C45.7807 8.95555 39.8857 3.06055 32.6557 3.06055C25.4257 3.06055 19.5307 8.95555 19.5307 16.1855C19.5307 16.7555 19.5757 17.3255 19.6507 17.8805H8.4907L7.3807 12.4055C7.3207 12.0905 7.0357 11.8655 6.7207 11.8655H2.8957C2.5207 11.8655 2.2207 12.1655 2.2207 12.5405C2.2207 12.9155 2.5207 13.2155 2.8957 13.2155H6.1657L8.44569 24.5105L10.5607 34.9955C10.6207 35.3105 10.9057 35.5355 11.2207 35.5355H32.5057C32.8207 35.5355 33.1057 35.3105 33.1657 34.9955L34.3357 29.1905C40.7707 28.3505 45.7507 22.8455 45.7507 16.1855H45.7807ZM31.9657 34.1855H11.7907L10.5157 27.9155L8.76069 19.2305H19.8907C21.2707 25.0055 26.4607 29.3105 32.6407 29.3105C32.7457 29.3105 32.8507 29.3105 32.9407 29.2955L31.9507 34.1855H31.9657ZM32.6557 27.9605C27.0007 27.9605 22.2607 23.9405 21.1357 18.6155C21.1357 18.6005 21.1357 18.5705 21.1357 18.5555C21.1357 18.4505 21.1057 18.3605 21.0607 18.2705C20.9407 17.5955 20.8657 16.9055 20.8657 16.1855C20.8657 9.69055 26.1457 4.41055 32.6407 4.41055C39.1357 4.41055 44.4157 9.69055 44.4157 16.1855C44.4157 22.6805 39.1357 27.9605 32.6407 27.9605H32.6557ZM40.4107 16.1855C40.4107 20.4605 36.9307 23.9555 32.6407 23.9555C30.4507 23.9555 28.4407 23.0555 26.9857 21.4955V22.7705C26.9857 23.1455 26.6857 23.4455 26.3107 23.4455C25.9357 23.4455 25.6357 23.1455 25.6357 22.7705V19.8455C25.6357 19.4705 25.9357 19.1705 26.3107 19.1705H29.1157C29.4907 19.1705 29.7907 19.4705 29.7907 19.8455C29.7907 20.2205 29.4907 20.5205 29.1157 20.5205H27.9157C29.1157 21.8405 30.7957 22.6055 32.6407 22.6055C36.1807 22.6055 39.0457 19.7255 39.0457 16.1855C39.0457 15.8105 39.3457 15.5105 39.7207 15.5105C40.0957 15.5105 40.3957 15.8105 40.3957 16.1855H40.4107ZM25.5607 16.8605C25.1857 16.8605 24.8857 16.5605 24.8857 16.1855C24.8857 11.9105 28.3657 8.41555 32.6557 8.41555C34.7557 8.41555 36.7207 9.27055 38.1607 10.7255V9.54055C38.1607 9.16555 38.4607 8.86555 38.8357 8.86555C39.2107 8.86555 39.5107 9.16555 39.5107 9.54055V12.3455C39.5107 12.5255 39.4357 12.6905 39.3157 12.8255C39.1957 12.9455 39.0157 13.0205 38.8357 13.0205H36.0007C35.6257 13.0205 35.3257 12.7205 35.3257 12.3455C35.3257 11.9705 35.6257 11.6705 36.0007 11.6705H37.2007C36.0157 10.4705 34.3957 9.76555 32.6557 9.76555C29.1157 9.76555 26.2507 12.6455 26.2507 16.1705C26.2507 16.5455 25.9507 16.8455 25.5757 16.8455L25.5607 16.8605Z" fill="currentColor"/></svg>';
  var ICON_MAIL = '<svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M44.9252 37.1702L44.1752 36.1052C43.9652 35.8052 43.8452 35.4602 43.8452 35.1002V30.4352C43.8452 27.7502 42.3302 25.4252 40.1252 24.2102C40.2452 23.8502 40.3202 23.4902 40.3202 23.1152C40.3202 21.3152 38.9852 19.8152 37.2452 19.5452V6.96016C37.2452 6.58516 36.9452 6.28516 36.5702 6.28516H4.66523C4.29023 6.28516 3.99023 6.58516 3.99023 6.96016V29.4302C3.99023 29.8052 4.29023 30.1052 4.66523 30.1052H12.7502V34.7552C12.7502 35.0102 12.9002 35.2502 13.1402 35.3702C13.2302 35.4152 13.3352 35.4302 13.4252 35.4302C13.5752 35.4302 13.7402 35.3702 13.8602 35.2802L20.0552 30.1202H29.5952C29.5952 30.2252 29.5652 30.3302 29.5652 30.4352V35.1002C29.5652 35.4602 29.4602 35.8202 29.2352 36.1052L28.4852 37.1702C28.2002 37.5602 28.1702 38.0852 28.3952 38.5202C28.6202 38.9552 29.0552 39.2252 29.5502 39.2252H33.2102C33.5252 40.8752 34.9802 42.1202 36.7052 42.1202C38.4302 42.1202 39.8852 40.8752 40.2002 39.2252H43.8602C44.3402 39.2252 44.7902 38.9552 45.0152 38.5202C45.2402 38.0852 45.1952 37.5752 44.9252 37.1702ZM38.9702 23.1002C38.9702 23.2952 38.9402 23.4752 38.8952 23.6552C38.2052 23.4302 37.4702 23.2802 36.6902 23.2802C35.9102 23.2802 35.1902 23.4302 34.4852 23.6552C34.4402 23.4752 34.4102 23.2802 34.4102 23.1002C34.4102 21.8552 35.4302 20.8352 36.6752 20.8352C37.9202 20.8352 38.9402 21.8552 38.9402 23.1002H38.9702ZM19.8002 28.7552C19.6352 28.7552 19.4852 28.8152 19.3652 28.9052L14.0852 33.3002V29.4302C14.0852 29.0552 13.7852 28.7552 13.4102 28.7552H5.32523V7.63516H35.8802V19.5752C34.2752 19.9352 33.0602 21.3752 33.0602 23.1002C33.0602 23.4752 33.1352 23.8352 33.2552 24.1952C31.5302 25.1552 30.2402 26.7902 29.7602 28.7552H19.7852H19.8002ZM36.7052 40.7552C35.7152 40.7552 34.8752 40.1102 34.5902 39.2102H38.8202C38.5352 40.1102 37.6952 40.7552 36.7052 40.7552ZM39.7352 37.8902C39.7352 37.8902 39.6452 37.8602 39.6002 37.8602H33.8102C33.7052 37.8602 33.6152 37.8902 33.5252 37.9202L29.5802 37.9502L30.3302 36.8852C30.7052 36.3602 30.9002 35.7302 30.9002 35.0852V30.4202C30.9002 27.2252 33.4952 24.6302 36.6902 24.6302C39.8852 24.6302 42.4802 27.2252 42.4802 30.4202V35.0852C42.4802 35.7302 42.6752 36.3602 43.0502 36.8852L43.7852 37.8602L39.7202 37.8902H39.7352ZM30.5252 17.7902C30.5252 18.1652 30.2252 18.4652 29.8502 18.4652H11.4152C11.0402 18.4652 10.7402 18.1652 10.7402 17.7902C10.7402 17.4152 11.0402 17.1152 11.4152 17.1152H29.8502C30.2252 17.1152 30.5252 17.4152 30.5252 17.7902ZM30.5252 14.6552C30.5252 15.0302 30.2252 15.3302 29.8502 15.3302H11.4152C11.0402 15.3302 10.7402 15.0302 10.7402 14.6552C10.7402 14.2802 11.0402 13.9802 11.4152 13.9802H29.8502C30.2252 13.9802 30.5252 14.2802 30.5252 14.6552ZM20.7302 20.9402C20.7302 21.3152 20.4302 21.6152 20.0552 21.6152H11.4002C11.0252 21.6152 10.7252 21.3152 10.7252 20.9402C10.7252 20.5652 11.0252 20.2652 11.4002 20.2652H20.0552C20.4302 20.2652 20.7302 20.5652 20.7302 20.9402Z" fill="currentColor"/></svg>';
  var ICON_RANK = '<svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.33893 10.3648C5.33893 10.3648 5.45894 10.3498 5.53394 10.3348L7.87393 18.0748C7.52893 18.1048 7.24394 18.3898 7.24394 18.7348V22.6198C7.24394 22.9948 7.54393 23.2948 7.91893 23.2948H25.0039C25.3789 23.2948 25.6789 22.9948 25.6789 22.6198V18.7348C25.6789 18.3748 25.3939 18.0898 25.0489 18.0748L27.3889 10.3348C27.3889 10.3348 27.5089 10.3648 27.5839 10.3648C28.2589 10.3648 28.9339 10.0048 29.2939 9.37477C29.8339 8.42977 29.5189 7.22977 28.5739 6.67477C27.6289 6.13477 26.4289 6.44977 25.8739 7.39477C25.5289 7.99477 25.5589 8.69977 25.8739 9.26977L20.5939 11.8648L17.4889 7.10977C18.0439 6.76477 18.4339 6.16477 18.4339 5.47477C18.4339 4.39477 17.5489 3.50977 16.4689 3.50977C15.3889 3.50977 14.5039 4.39477 14.5039 5.47477C14.5039 6.17977 14.8939 6.76477 15.4489 7.10977L12.3439 11.8648L7.06394 9.26977C7.36394 8.68477 7.40894 7.99477 7.06394 7.39477C6.52394 6.44977 5.30894 6.13477 4.36394 6.67477C3.91394 6.94477 3.58394 7.36477 3.44894 7.87477C3.31394 8.38477 3.38892 8.90977 3.64392 9.37477C3.91392 9.82477 4.33393 10.1548 4.84393 10.2898C5.00893 10.3348 5.18894 10.3648 5.35394 10.3648H5.33893ZM24.3289 21.9448H8.59393V19.4098H24.3289V21.9448ZM27.0439 8.08477C27.1639 7.88977 27.3739 7.76977 27.5839 7.76977C27.6889 7.76977 27.7939 7.79977 27.8989 7.85977C28.0489 7.94977 28.1389 8.06977 28.1839 8.23477C28.2289 8.39977 28.1989 8.56477 28.1239 8.69977C28.0489 8.83477 27.9139 8.93977 27.7489 8.98477C27.5839 9.02977 27.4189 8.99977 27.2839 8.92477C27.1339 8.83477 27.0439 8.71477 26.9989 8.54977C26.9539 8.38477 26.9839 8.21977 27.0589 8.08477H27.0439ZM16.4539 4.87477C16.7989 4.87477 17.0689 5.15977 17.0689 5.48977C17.0689 5.81977 16.7839 6.10477 16.4539 6.10477C16.1239 6.10477 15.8389 5.81977 15.8389 5.48977C15.8389 5.15977 16.1239 4.87477 16.4539 4.87477ZM12.2689 13.3648C12.5689 13.5148 12.9439 13.4098 13.1389 13.1248L16.4689 8.02477L19.7839 13.1248C19.9639 13.4098 20.3389 13.5148 20.6539 13.3648L25.8439 10.8148L23.6389 18.0748H9.28394L7.07894 10.8148L12.2689 13.3648ZM5.02394 7.84477C5.11394 7.78477 5.23393 7.75477 5.33893 7.75477C5.54893 7.75477 5.75893 7.85977 5.87893 8.06977C5.96893 8.21977 5.98394 8.38477 5.93894 8.53477C5.89394 8.69977 5.78894 8.83477 5.65394 8.90977C5.51894 8.98477 5.33894 9.01477 5.18894 8.96977C5.02394 8.92477 4.88894 8.81977 4.81394 8.68477C4.64894 8.38477 4.73893 8.00977 5.03893 7.82977L5.02394 7.84477ZM43.9639 16.4998H36.1639C35.7889 16.4998 35.4889 16.7998 35.4889 17.1748V21.1348H28.3639C27.9889 21.1348 27.6889 21.4348 27.6889 21.8098V25.7698H20.5639C20.1889 25.7698 19.8889 26.0698 19.8889 26.4448V30.4048H12.7639C12.3889 30.4048 12.0889 30.7048 12.0889 31.0798V35.0398H4.96393C4.58893 35.0398 4.28893 35.3398 4.28893 35.7148V42.6748C4.28893 43.0498 4.58893 43.3498 4.96393 43.3498H43.9639C44.3389 43.3498 44.6389 43.0498 44.6389 42.6748V17.1748C44.6389 16.7998 44.3389 16.4998 43.9639 16.4998ZM5.63893 36.3898H12.0889V41.9998H5.63893V36.3898ZM13.4389 35.7148V31.7548H19.8889V41.9998H13.4389V35.7148ZM21.2389 31.0798V27.1198H27.6889V41.9998H21.2389V31.0798ZM29.0389 26.4448V22.4848H35.4889V41.9998H29.0389V26.4448ZM43.2889 41.9998H36.8389V17.8498H43.2889V41.9998Z" fill="currentColor"/></svg>';
  var customer = document.querySelector('.customer.login');

  // ===== 会員の方はこちら（ログイン＝グレー枠）=====
  var emailInput = document.getElementById('CustomerEmail');
  var loginForm = emailInput ? emailInput.closest('form') : null;
  if (loginForm) loginForm.classList.add('mw-login-form');

  var emailLabel = document.querySelector('label[for="CustomerEmail"]');
  if (emailLabel) emailLabel.textContent = 'メールアドレス';
  if (emailInput) emailInput.setAttribute('placeholder', 'メールアドレス');
  var passLabel = document.querySelector('label[for="CustomerPassword"]');
  if (passLabel) passLabel.textContent = 'パスワード';
  var passInput = document.getElementById('CustomerPassword');
  if (passInput) passInput.setAttribute('placeholder', 'パスワード');

  if (loginForm) {
    var loginBtn = loginForm.querySelector(':scope > button');
    if (loginBtn) loginBtn.textContent = '会員ログイン';
    // フォーム内のcreate_accountリンクは非表示（新規登録は「初めての方へ」側に集約）
    var inFormReg = loginForm.querySelector('a[href*="/account/register"]');
    if (inFormReg) inFormReg.style.display = 'none';
  }

  // 見出し「会員の方はこちら」＋アイコン（グレー枠の上）
  if (loginForm && !document.querySelector('.mw-login-head--member')) {
    var mhead = document.createElement('div');
    mhead.className = 'mw-login-head mw-login-head--member';
    mhead.innerHTML = '<span class="mw-login-head__ico">' + ICON_LOGIN + '</span><h2 class="mw-login-head__title">会員の方はこちら</h2>';
    loginForm.parentNode.insertBefore(mhead, loginForm);
  }

  // ===== パスワードリセット（recoverフォーム・同ページ #recover）=====
  var recoverInput = document.getElementById('RecoverEmail');
  var recoverForm = recoverInput ? recoverInput.closest('form') : null;
  if (recoverForm) recoverForm.classList.add('mw-recover-form');
  var recoverLabel = document.querySelector('label[for="RecoverEmail"]');
  if (recoverLabel) recoverLabel.textContent = 'メールアドレス';
  if (recoverInput) recoverInput.setAttribute('placeholder', 'メールアドレス');
  // キャンセル(左)＋送信(右)を横並びにラップ
  if (recoverForm && !recoverForm.querySelector('.mw-recover-actions')) {
    var rBtn = recoverForm.querySelector('button');
    var rCancel = recoverForm.querySelector('a[href="#login"]');
    if (rBtn && rCancel) {
      var racts = document.createElement('div');
      racts.className = 'mw-recover-actions';
      rBtn.parentNode.insertBefore(racts, rBtn);
      racts.appendChild(rCancel);
      racts.appendChild(rBtn);
    }
  }

  // ===== 初めての方へ（区切り見出し＋新規登録ピル＋ポイントカード）=====
  var extReg = null, allReg = document.querySelectorAll('a[href*="/account/register"]');
  for (var r = 0; r < allReg.length; r++) { if (!allReg[r].closest('.customer.login')) { extReg = allReg[r]; break; } }
  var registerUrl = extReg ? extReg.getAttribute('href') : '/account/register';
  // 登録案内(rich-text)と直前の区切りhrを隠す
  var rts = document.querySelectorAll('.rich-text');
  for (var q = 0; q < rts.length; q++) {
    if (!rts[q].querySelector('a[href*="/account/register"]')) continue;
    var sec = rts[q].closest('.shopify-section') || rts[q];
    sec.style.display = 'none';
    var prev = sec.previousElementSibling;
    if (prev && prev.querySelector && prev.querySelector('hr')) prev.style.display = 'none';
  }

  if (customer && !document.querySelector('.mw-login-newcomer')) {
    var pointCards = [
      {
        icon: ICON_POINT,
        main: 'ポイントが貯まる！使える！'
      },
      {
        icon: ICON_COUPON,
        main: '会員限定クーポンが貰える'
      },
      {
        icon: ICON_CART,
        main: '2回目以降のお買い物が簡単に'
      },
      {
        icon: ICON_MAIL,
        main: 'メールやアプリで<br>お得な情報をいち早くお届け'
      },
      {
        icon: ICON_RANK,
        main: '会員ランク制度<br>ご購入金額によって会員ステータスアップ！'
      }
    ];

    var cards = '';

    pointCards.forEach(function(card) {
      cards +=
        '<div class="mw-login-points__card">' +
          '<span class="mw-login-points__ribbon"></span>' +
          '<span class="mw-login-points__icon">' + card.icon + '</span>' +
          '<span class="mw-login-points__body">' +
            '<strong class="mw-login-points__main">' + card.main + '</strong>' +
          '</span>' +
        '</div>';
    });
    var nc = document.createElement('div');
    nc.className = 'mw-login-newcomer';
    nc.id = 'fv';
    nc.innerHTML =
      '<div class="mw-login-head mw-login-head--new"><span class="mw-login-head__ico">' + ICON_SHIELD + '</span><h2 class="mw-login-head__title">初めての方へ</h2></div>' +
      '<p class="mw-login-newcomer__lead">入会金・年会費不要！<br class="mw-newcomer-br">会員登録すると便利でお得！</p>' +
      '<div class="mw-login-newcomer__rule">' +
        '<svg class="mw-rule mw-rule--pc" viewBox="0 0 368 10" fill="none" xmlns="http://www.w3.org/2000/svg"><line x1="191" y1="0.6" x2="368" y2="0.6" stroke="currentColor"/><g clip-path="url(#mwrule)"><line y1="0.6" x2="183" y2="0.6" stroke="currentColor"/><path d="M191 8.6L184.685 0.6L183 0.6" stroke="currentColor"/></g><defs><clipPath id="mwrule"><rect width="192" height="9" fill="white" transform="translate(0 0.0996)"/></clipPath></defs></svg>' +
        '<svg class="mw-rule mw-rule--sp" viewBox="0 0 208 9" fill="none" xmlns="http://www.w3.org/2000/svg"><line x1="109" y1="0.5" x2="208" y2="0.5" stroke="currentColor"/><g clip-path="url(#mwrulesp)"><line y1="0.5" x2="100" y2="0.5" stroke="currentColor"/><path d="M108 8.5L101.685 0.5L100 0.5" stroke="currentColor"/></g><defs><clipPath id="mwrulesp"><rect width="109" height="9" fill="white"/></clipPath></defs></svg>' +
      '</div>' +
      '<div class="mw-login-newcomer__cta"><a href="' + registerUrl + '" class="mw-login-register">新規会員登録</a></div>' +
      '<div class="mw-login-points">' + cards + '</div>';
    customer.appendChild(nc);
  }
});

// 260711 会員登録改修 weblab（260712 デザイン反映）
document.addEventListener('DOMContentLoaded', function () {
  if (!/^\/account\/register\/?$/.test(window.location.pathname)) return;
  document.body.classList.add('register-page');

  var wrap = document.querySelector('.customer.register');
  if (!wrap) return;

  // タイトル：新規会員登録
  var h1 = wrap.querySelector('h1');
  if (h1) h1.textContent = '新規会員登録';

  // フォームにフック付与（グレー枠用）
  var form = wrap.querySelector('form');
  if (form) form.classList.add('mw-register-form');

  // プレースホルダ：姓 / 名 / メールアドレス / パスワード（設計はプレースホルダのみ）
  var setPh = function (id, ph) { var el = document.getElementById(id); if (el) el.setAttribute('placeholder', ph); };
  setPh('RegisterForm-LastName', '姓');
  setPh('RegisterForm-FirstName', '名');
  setPh('RegisterForm-email', 'メールアドレス');
  setPh('RegisterForm-password', 'パスワード');
  var emailLabel = wrap.querySelector('label[for="RegisterForm-email"]');
  if (emailLabel) emailLabel.textContent = 'メールアドレス';

  // メルマガ文言：メルマガ配信を希望する → メールマガジン配信を希望する
  var mkLabel = wrap.querySelector('label[for="accepts-marketing"]');
  if (mkLabel) mkLabel.textContent = 'メールマガジン配信を希望する';

  // ボタン：この内容で会員登録する
  var btn = form ? form.querySelector('button') : null;
  if (btn) btn.textContent = 'この内容で会員登録する';

  // 注記「※ご住所は購入手続き時にご入力いただけます。」をボタンの上に追加
  if (form && btn && !form.querySelector('.mw-register-note')) {
    var note = document.createElement('p');
    note.className = 'mw-register-note';
    note.textContent = '※ご住所は購入手続き時にご入力いただけます。';
    btn.parentNode.insertBefore(note, btn);
  }
});

// 260711 パスワードリセット(PW入力)改修 weblab（260712 デザイン反映）
document.addEventListener('DOMContentLoaded', function () {
  if (!/^\/account\/reset\//.test(window.location.pathname)) return;
  document.body.classList.add('reset-page');
  var wrap = document.querySelector('.customer.reset-password');
  if (!wrap) return;
  var form = wrap.querySelector('form');
  if (form) form.classList.add('mw-reset-form');
  // プレースホルダ：パスワード / パスワードを確認する
  var pw = wrap.querySelector('input[name="customer[password]"]');
  if (pw) pw.setAttribute('placeholder', 'パスワード');
  var pc = wrap.querySelector('input[name="customer[password_confirmation]"]');
  if (pc) pc.setAttribute('placeholder', 'パスワードを確認する');
});

// 260712 会員情報編集(215) weblab（/account?view=edit・Customer Fieldsアプリ描画）
document.addEventListener('DOMContentLoaded', function () {
  if (!(/^\/account\/?$/.test(window.location.pathname) && /[?&]view=edit/.test(window.location.search))) return;
  document.body.classList.add('account-edit-page');
  var wrap = document.querySelector('.full__page__form');
  if (!wrap) return;
  // 戻りリンク：文言をマイページに戻るへ・親divに白ピル用フック
  var back = wrap.querySelector('a[href="/account"], a[href$="/account"]');
  if (back) {
    back.textContent = 'マイページに戻る';
    if (back.parentNode && back.parentNode !== wrap) back.parentNode.classList.add('mw-account-back');
  }
  // ※リセットリンクはフォーム内のまま（外に出すと送信後の確認差し替えが壊れる）。見た目はCSSで
  // 送信後の確認メッセージをデザイン文言＋改行に差し替え（アプリが動的注入するため監視）
  var fixResetSentMsg = function () {
    var box = document.querySelector('.cf-verify-email-message [data-reach-alert]') ||
              document.querySelector('.cf-verify-email-message');
    if (!box) return;
    if (box.getAttribute('data-mw-reset-msg') === '1') return;
    box.innerHTML = 'パスワードをリセットするリンクを<br>メールで送信しました';
    box.setAttribute('data-mw-reset-msg', '1');
  };
  fixResetSentMsg();
  var moReset = new MutationObserver(fixResetSentMsg);
  moReset.observe(document.body, { childList: true, subtree: true });
});

// 260712 マイページ(214) weblab
document.addEventListener('DOMContentLoaded', function () {
  if (!(/^\/account\/?$/.test(window.location.pathname) && !/[?&]view=/.test(window.location.search))) return;
  document.body.classList.add('mypage-page');
  var h1 = document.querySelector('.account-header__left');
  if (h1) h1.textContent = 'マイページ';

  // お気に入り集約：メニューを「お気に入り」1つに（Swymを入口・コーデ/スタッフは非表示）
  var favProd = document.querySelector('.mw_account_menu_item.item-fav-prod');
  if (favProd) {
    favProd.setAttribute('href', '/pages/swym-wishlist');
    var favSpan = favProd.querySelector('span');
    if (favSpan) favSpan.textContent = 'お気に入り';
    favProd.classList.add('mw-fav-merged');
  }
  var favCoord = document.querySelector('.mw_account_menu_item.item-fav-coord');
  if (favCoord) favCoord.style.display = 'none';

  // ブランド帯の見出し文言（Mattrz遅延注入をMutationObserverで追従）
  var brandTitleFix = function () {
    var done = false;
    document.querySelectorAll('._fs_title').forEach(function (el) {
      if ((el.textContent || '').trim() === 'ブランドから商品を探す') {
        el.textContent = 'ブランドから他の商品を探す';
        done = true;
      }
    });
    return done;
  };
  // ブランド帯の中央に「sab street bis」カードを暫定注入（本筋はMattrz側）
  var insertBisCard = function () {
    var row = document.querySelector('#mattrz-cx-campaign-element-campaign-75835 ._fs_row');
    if (!row) return false;
    if (row.querySelector('.mw-bis-card')) return true; // 既に注入済み
    var cols = row.querySelectorAll(':scope > ._fs_column');
    if (cols.length < 2) return false; // 既存2枚が揃うまで待つ
    var col = document.createElement('div');
    col.className = '_fs_column mw-bis-col';
    col.innerHTML = '<div class="_fs_inner-column">' +
      '<a href="/pages/sabstreetbis" class="_fs_image-link mw-bis-card" title="sab street bis" aria-label="sab street bis"></a>' +
      '</div>';
    row.insertBefore(col, cols[1]); // 中央（2枚目の直前）
    return true;
  };

  // 260715 各バナー下にブランド名リンク weblab
  var addBrandLabels = function () {
    var row = document.querySelector('#mattrz-cx-campaign-element-campaign-75835 ._fs_row');
    if (!row) return false;
    var cols = row.querySelectorAll(':scope > ._fs_column');
    if (!cols.length) return false;
    var map = [
      { re: /bis/i, name: 'sab street bis' },
      { re: /jetset/i, name: 'JETSET SOLO PLUS' },
      { re: /(sabstreet|my-?standard)/i, name: 'sab street my standard' }
    ];
    cols.forEach(function (col) {
      var inner = col.querySelector('._fs_inner-column') || col;
      if (inner.querySelector('.mw-brand-label')) return;
      var a = col.querySelector('a._fs_image-link') || col.querySelector('a[href]');
      var href = a ? (a.getAttribute('href') || '') : '';
      var name = null;
      for (var i = 0; i < map.length; i++) { if (map[i].re.test(href)) { name = map[i].name; break; } }
      if (!name) return;
      var label = document.createElement('a');
      label.className = 'mw-brand-label';
      label.href = href;
      label.innerHTML = name + '<span class="mw-brand-arrow">›</span>';
      inner.appendChild(label);
    });
    return true;
  };

  var syncBrand = function () { brandTitleFix(); insertBisCard(); addBrandLabels(); };
  syncBrand();
  var moBrand = new MutationObserver(function () { syncBrand(); });
  moBrand.observe(document.body, { childList: true, subtree: true });
  setTimeout(function () { moBrand.disconnect(); }, 20000);
});

// 260713 お気に入り集約（共有タブバー）weblab
//   Swym(商品)とStaffStart(コーデ/スタッフ)の2ページに共通の3タブを出し、リンクで行き来する
document.addEventListener('DOMContentLoaded', function () {
  var path = window.location.pathname, q = window.location.search;
  var isSwym = /^\/pages\/swym-wishlist\/?$/.test(path);
  var isStaff = /^\/apps\/staffstart\/myPage\/?$/.test(path);
  if (!isSwym && !isStaff) return;
  document.body.classList.add('mw-fav-page');
  var active = isSwym ? 'product' : (/[?&]tab=coordinate/.test(q) ? 'coordinate' : 'staff');

  var title = document.createElement('h1');
  title.className = 'mw-fav-title';
  title.textContent = 'お気に入り';

  var bar = document.createElement('nav');
  bar.className = 'mw-fav-tabs';
  bar.setAttribute('aria-label', 'お気に入り');
  bar.innerHTML =
    '<a href="/pages/swym-wishlist" class="mw-fav-tab" data-tab="product">商品</a>' +
    '<a href="/apps/staffstart/myPage?tab=coordinate" class="mw-fav-tab" data-tab="coordinate">コーディネート</a>' +
    '<a href="/apps/staffstart/myPage" class="mw-fav-tab" data-tab="staff">スタッフ</a>';
  var act = bar.querySelector('[data-tab="' + active + '"]');
  if (act) act.classList.add('is-active');

  var anchorId = isSwym ? 'swym-wishlist-render-container' : 'staffstart-shopify-app-container';
  var cont = document.getElementById(anchorId);
  if (cont && cont.parentNode) {
    cont.parentNode.insertBefore(title, cont);
    cont.parentNode.insertBefore(bar, cont);
  }

  if (isStaff) {
    // StaffStart自前のタブバー・タイトルを隠す（sc-*は不安定なのでテキスト/構造で特定・MutationObserverで追従）
    var hideStaffDup = function () {
      var a = Array.prototype.find.call(
        document.querySelectorAll('#staffstart-shopify-app-container a'),
        function (x) { return /^(スタッフ|コーディネート)$/.test((x.textContent || '').trim()); });
      if (a && a.parentElement && !a.parentElement.classList.contains('mw-fav-tabs')) {
        a.parentElement.style.display = 'none';
      }
      Array.prototype.forEach.call(
        document.querySelectorAll('#staffstart-shopify-app-container h1, #staffstart-shopify-app-container h2, #staffstart-shopify-app-container h3'),
        function (h) { if (/お気に入り一覧|お気に入り/.test(h.textContent || '')) h.style.display = 'none'; });
      // パンくず（TOP＋マイページの両リンクを含む親div）にフック付与
      Array.prototype.forEach.call(
        document.querySelectorAll('#staffstart-shopify-app-container a[href="/apps/staffstart/myPage"]'),
        function (m) { var par = m.parentElement; if (par && par.querySelector('a[href="/"]')) par.classList.add('mw-ss-breadcrumb'); });
      // 件数（コーディネート数/スタッフ数）の親div
      Array.prototype.forEach.call(
        document.querySelectorAll('#staffstart-shopify-app-container span'),
        function (s) { if (/(コーディネート数|スタッフ数|件数)/.test(s.textContent || '') && s.parentElement) s.parentElement.classList.add('mw-ss-count'); });
      // グリッド（articleの親でdisplay:grid）＋カード
      Array.prototype.forEach.call(
        document.querySelectorAll('#staffstart-shopify-app-container article'),
        function (art) { var g = art.parentElement; if (g && getComputedStyle(g).display === 'grid') g.classList.add('mw-ss-grid'); art.classList.add('mw-ss-card'); });
      // 身長（Ncm／【Ncm】）。スタッフは名前と同行なので親を「名前+身長」行として印付け→CSSで改行
      Array.prototype.forEach.call(
        document.querySelectorAll('#staffstart-shopify-app-container p'),
        function (pp) {
          if (/^\s*【?\s*\d{2,3}\s*cm\s*】?\s*$/.test(pp.textContent || '')) {
            pp.classList.add('mw-ss-height');
            var par = pp.parentElement;
            if (par && par.children.length >= 2) par.classList.add('mw-ss-name-height');
          }
        });
    };
    hideStaffDup();
    var moStaff = new MutationObserver(hideStaffDup);
    moStaff.observe(cont || document.body, { childList: true, subtree: true });
    setTimeout(function () { moStaff.disconnect(); }, 25000);
  } else {
    // Swym側（商品タブ）。カード全体のクリック先を商品詳細へ（削除/カート追加ボタンは素通し）
    if (cont) {
      cont.addEventListener('click', function (e) {
        var item = e.target.closest('.swym-wishlist-item');
        if (!item) return;
        if (e.target.closest('.swym-delete-btn, .swym-add-to-cart-btn')) return;
        var link = item.querySelector('.swym-wishlist-image-wrapper');
        var href = link && link.getAttribute('href');
        if (!href) return;
        e.stopPropagation();
        e.preventDefault();
        window.location.href = href;
      }, true);
    }
    // 各カードにブランド名を注入（商品JSONのvendorを取得・handleごとにキャッシュ。本筋はSwym側）
    var brandCache = {};
    var addBrands = function () {
      document.querySelectorAll('#swym-wishlist-render-container .swym-wishlist-item').forEach(function (item) {
        if (item.getAttribute('data-mw-brand') === '1') return;
        var link = item.querySelector('.swym-wishlist-image-wrapper');
        var href = link && link.getAttribute('href');
        var m = href && href.match(/\/products\/([^/?#]+)/);
        if (!m) return;
        item.setAttribute('data-mw-brand', '1');
        var handle = m[1];
        var insert = function (vendor) {
          if (!vendor || item.querySelector('.mw-fav-brand')) return;
          var title = item.querySelector('.swym-title, .swym-title-1');
          var anchor = title ? (title.closest('button') || title) : null;
          if (!anchor || !anchor.parentNode) return;
          var el = document.createElement('div');
          el.className = 'mw-fav-brand';
          el.textContent = vendor;
          anchor.parentNode.insertBefore(el, anchor);
        };
        if (brandCache[handle] !== undefined) { insert(brandCache[handle]); return; }
        fetch('/products/' + handle + '.js').then(function (r) { return r.ok ? r.json() : null; })
          .then(function (d) { var v = (d && d.vendor) || ''; brandCache[handle] = v; insert(v); })
          .catch(function () { brandCache[handle] = ''; });
      });
    };
    // 「カートに追加」→「カートに入れる」に文言だけ差し替え（nodeValueで書換＝ノード参照維持・二重表示防止）
    var relabelCart = function () {
      document.querySelectorAll('#swym-wishlist-render-container .swym-add-to-cart-btn').forEach(function (btn) {
        Array.prototype.forEach.call(btn.childNodes, function (n) {
          if (n.nodeType === 3 && (n.nodeValue || '').trim() === 'カートに追加') n.nodeValue = 'カートに入れる';
        });
      });
    };
    // 三本線ヘッダーを丸ごとメール行へ移動（内部構造を保持しメニューを壊さない）
    var moveHeader = function () {
      var header = document.querySelector('#swym-wishlist-render-container .swym-wishlist-detail-header');
      var bar = document.querySelector('#swym-wishlist-render-container .swym-wishlist-container-title-bar');
      if (header && bar && header.parentNode !== bar) bar.appendChild(header);
    };
    var syncSwym = function () { addBrands(); relabelCart(); moveHeader(); };
    syncSwym();
    var moSwym = new MutationObserver(syncSwym);
    moSwym.observe(cont || document.body, { childList: true, subtree: true });
    setTimeout(function () { moSwym.disconnect(); }, 25000);
  }
});

// 260711 配送先住所改修 weblab
document.addEventListener('DOMContentLoaded', function () {
  if (!/^\/account\/addresses\/?$/.test(window.location.pathname)) return;
  document.body.classList.add('addresses-page');
  var root = document.querySelector('.customer.addresses');
  if (!root) return;

  // 見出し「住所」→「配送先住所」
  var h1 = root.querySelector('h1');
  if (h1) h1.textContent = '配送先住所';

  // 「住所」→「配送先」系のリネーム（全インスタンス・完全一致で安全に置換）
  var map = {
    'アカウントの詳細に戻る': 'マイページに戻る',
    '新しい住所を追加': '新しい配送先を追加',
    '住所を追加する': '配送先を追加',
    'デフォルト': '現在の配送先',
    '住所を編集する': '配送先を編集する',
    '住所を更新する': '配送先を更新',
    'キャンセルする': 'キャンセル'
  };
  root.querySelectorAll('h2, button, a').forEach(function (el) {
    var t = (el.textContent || '').trim();
    if (map[t]) el.textContent = map[t];
  });

  // プレースホルダ（全フォーム共通・input name で一括）
  var ph = {
    'address[last_name]': '姓', 'address[first_name]': '名', 'address[zip]': '郵便番号',
    'address[city]': '市区町村', 'address[address1]': '町名・丁目・番地',
    'address[address2]': '建物名・部屋番号など', 'address[phone]': '電話番号'
  };
  Object.keys(ph).forEach(function (n) {
    root.querySelectorAll('input[name="' + n + '"]').forEach(function (el) { el.setAttribute('placeholder', ph[n]); });
  });

  // 各フォーム：ボタン(キャンセル左・送信右)を横並びにラップ
  root.querySelectorAll('form').forEach(function (form) {
    var submitBtn = form.querySelector('button:not([type="reset"]):not([type="button"])');
    var cancelBtn = form.querySelector('button[type="reset"]');
    if (submitBtn && cancelBtn && !form.querySelector('.mw-addr-actions')) {
      var acts = document.createElement('div');
      acts.className = 'mw-addr-actions';
      submitBtn.parentNode.insertBefore(acts, submitBtn);
      acts.appendChild(cancelBtn);
      acts.appendChild(submitBtn);
    }
  });
});


/* ==============================================================
2026-07-17 金井作業分
============================================================== */

document.addEventListener('DOMContentLoaded', function () {
  var guideDetails = Array.prototype.slice.call(
    document.querySelectorAll('.mw-guide-card__details')
  );

  if (!guideDetails.length) {
    return;
  }

  var mql = window.matchMedia('(max-width: 749px)');
  var resizeTimer = null;

  function resetGuideCardHeights() {
    guideDetails.forEach(function (details) {
      details.style.minHeight = '';
    });
  }

  function equalizeOpenGuideCards() {
    resetGuideCardHeights();

    // スマホでは高さを揃えない
    if (mql.matches) {
      return;
    }

    var rows = [];

    guideDetails.forEach(function (details) {
      // 閉じているカードは高さ揃えの対象外
      if (!details.open) {
        return;
      }

      var top = Math.round(details.getBoundingClientRect().top);

      var row = rows.find(function (item) {
        return Math.abs(item.top - top) <= 2;
      });

      if (!row) {
        row = {
          top: top,
          items: []
        };

        rows.push(row);
      }

      row.items.push(details);
    });

    rows.forEach(function (row) {
      var maxHeight = Math.max.apply(
        null,
        row.items.map(function (details) {
          return details.scrollHeight;
        })
      );

      row.items.forEach(function (details) {
        details.style.minHeight = maxHeight + 'px';
      });
    });
  }

  function syncGuideAccordionState() {
    guideDetails.forEach(function (details) {
      details.open = !mql.matches;
      details.style.height = '';
      details.style.overflow = '';
    });

    window.requestAnimationFrame(function () {
      equalizeOpenGuideCards();
    });
  }

  guideDetails.forEach(function (details) {
    var summary = details.querySelector('.mw-guide-card__summary');
    var content = details.querySelector('.mw-guide-card__list');

    if (!summary || !content) {
      return;
    }

    var animation = null;
    var isClosing = false;
    var isExpanding = false;

    summary.addEventListener('click', function (event) {
      // PCでも開閉できるようにする
      event.preventDefault();

      details.style.minHeight = '';
      details.style.overflow = 'hidden';

      if (isClosing || !details.open) {
        openAccordion();
      } else if (isExpanding || details.open) {
        shrinkAccordion();
      }
    });

    function shrinkAccordion() {
      isClosing = true;

      var startHeight = details.offsetHeight + 'px';
      var endHeight = summary.offsetHeight + 'px';

      if (animation) {
        animation.cancel();
      }

      animation = details.animate(
        {
          height: [startHeight, endHeight]
        },
        {
          duration: 200,
          easing: 'ease-out'
        }
      );

      animation.onfinish = function () {
        finishAnimation(false);
      };

      animation.oncancel = function () {
        isClosing = false;
      };
    }

    function openAccordion() {
      details.style.height = details.offsetHeight + 'px';
      details.open = true;

      window.requestAnimationFrame(function () {
        expandAccordion();
      });
    }

    function expandAccordion() {
      isExpanding = true;

      var startHeight = details.offsetHeight + 'px';
      var endHeight =
        summary.offsetHeight +
        content.scrollHeight +
        'px';

      if (animation) {
        animation.cancel();
      }

      animation = details.animate(
        {
          height: [startHeight, endHeight]
        },
        {
          duration: 200,
          easing: 'ease-out'
        }
      );

      animation.onfinish = function () {
        finishAnimation(true);
      };

      animation.oncancel = function () {
        isExpanding = false;
      };
    }

    function finishAnimation(isOpen) {
      details.open = isOpen;
      animation = null;
      isClosing = false;
      isExpanding = false;
      details.style.height = '';
      details.style.overflow = '';

      window.requestAnimationFrame(function () {
        equalizeOpenGuideCards();
      });
    }
  });

  syncGuideAccordionState();

  if (typeof mql.addEventListener === 'function') {
    mql.addEventListener('change', syncGuideAccordionState);
  } else {
    mql.addListener(syncGuideAccordionState);
  }

  window.addEventListener('resize', function () {
    window.clearTimeout(resizeTimer);

    resizeTimer = window.setTimeout(function () {
      equalizeOpenGuideCards();
    }, 150);
  });
});

/* 店舗からのお知らせ 統合一覧(ブログ+イベントをJSで日付マージ+ページ送り) */
document.addEventListener('DOMContentLoaded', function () {
  var root = document.querySelector('[data-mw-news]');
  if (!root) return;

  var grid = root.querySelector('[data-mw-news-grid]');
  var pager = root.querySelector('[data-mw-news-pager]');
  var status = root.querySelector('[data-mw-news-status]');
  var perPage = parseInt(root.getAttribute('data-per-page'), 10) || 12;
  var blogHandle = root.getAttribute('data-blog-handle');
  var eventHandle = root.getAttribute('data-event-handle');
  var labelBlog = root.getAttribute('data-label-blog') || 'ブログ';
  var labelEvent = root.getAttribute('data-label-event') || 'イベント';
  var VIEW = 'news-feed';
  var CHEVRON_R =
    '<svg width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M4 1L9 6L4 11" stroke="currentColor" stroke-width="1.5"/></svg>';
  var CHEVRON_L =
    '<svg width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M8 1L3 6L8 11" stroke="currentColor" stroke-width="1.5"/></svg>';

  var allArticles = [];

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function feedUrl(handle, page) {
    return '/blogs/' + handle + '?view=' + VIEW + '&page=' + page;
  }

  function fetchJson(url) {
    return fetch(url, { headers: { Accept: 'application/json' } }).then(function (r) {
      return r.text().then(function (t) {
        return JSON.parse(t);
      });
    });
  }

  function fetchFeed(handle, type) {
    if (!handle) return Promise.resolve([]);
    return fetchJson(feedUrl(handle, 1))
      .then(function (data) {
        var out = markType(data.articles, type);
        var pages = data.pages || 1;
        if (pages <= 1) return out;
        var reqs = [];
        for (var p = 2; p <= pages; p++) {
          reqs.push(fetchJson(feedUrl(handle, p)));
        }
        return Promise.all(reqs).then(function (list) {
          list.forEach(function (d) {
            out = out.concat(markType(d.articles, type));
          });
          return out;
        });
      })
      .catch(function () {
        return [];
      });
  }

  function markType(list, type) {
    list = list || [];
    list.forEach(function (a) {
      a.type = type;
    });
    return list;
  }

  function currentPage() {
    var m = window.location.search.match(/[?&]page=(\d+)/);
    var p = m ? parseInt(m[1], 10) : 1;
    return p > 0 ? p : 1;
  }

  function pageHref(p) {
    var params = new URLSearchParams(window.location.search);
    params.set('page', p);
    return window.location.pathname + '?' + params.toString();
  }

  function cardHtml(a) {
    var label = a.type === 'event' ? labelEvent : labelBlog;
    var title = a.title || '';
    if (title.length > 50) title = title.slice(0, 50) + '…';
    var img = a.image
      ? '<img class="mw-news-card__img" src="' +
        esc(a.image) +
        '" srcset="' +
        esc(a.image_sm || a.image) +
        ' 334w, ' +
        esc(a.image) +
        ' 668w" sizes="(min-width: 750px) 334px, calc(100vw - 32px)" alt="' +
        esc(a.alt || '') +
        '" loading="lazy">'
      : '';
    return (
      '<a class="mw-news-card" href="' +
      esc(a.url) +
      '">' +
      '<span class="mw-news-card__thumb">' +
      img +
      '</span>' +
      '<span class="mw-news-card__body">' +
      '<span class="mw-news-card__badge">' +
      esc(label) +
      '</span>' +
      '<span class="mw-news-card__headline">' +
      '<span class="mw-news-card__title">' +
      esc(title) +
      '</span>' +
      '<span class="mw-news-card__arrow" aria-hidden="true">' +
      CHEVRON_R +
      '</span>' +
      '</span>' +
      '<span class="mw-news-card__date">' +
      esc(a.date) +
      '</span>' +
      '</span>' +
      '</a>'
    );
  }

  function buildPager(current, totalPages) {
    pager.innerHTML = '';
    if (totalPages <= 1) return;

    var nums = [];
    function push(n) {
      if (n >= 1 && n <= totalPages && nums.indexOf(n) === -1) nums.push(n);
    }
    push(1);
    push(current - 1);
    push(current);
    push(current + 1);
    push(totalPages);
    nums.sort(function (a, b) {
      return a - b;
    });

    if (current > 1) pager.appendChild(arrowEl(current - 1, 'prev'));

    var prev = 0;
    nums.forEach(function (n) {
      if (prev && n - prev > 1) {
        var e = document.createElement('span');
        e.className = 'mw-news-pager__ellipsis';
        e.textContent = '…';
        pager.appendChild(e);
      }
      pager.appendChild(numEl(n, current));
      prev = n;
    });

    if (current < totalPages) pager.appendChild(arrowEl(current + 1, 'next'));
  }

  function numEl(n, current) {
    var a = document.createElement('a');
    a.className = 'mw-news-pager__num' + (n === current ? ' is-current' : '');
    a.href = pageHref(n);
    a.textContent = n;
    if (n === current) a.setAttribute('aria-current', 'page');
    a.addEventListener('click', onPagerClick);
    return a;
  }

  function arrowEl(n, dir) {
    var a = document.createElement('a');
    a.className = 'mw-news-pager__arrow mw-news-pager__arrow--' + dir;
    a.href = pageHref(n);
    a.setAttribute('aria-label', dir === 'next' ? '次のページ' : '前のページ');
    a.innerHTML = dir === 'next' ? CHEVRON_R : CHEVRON_L;
    a.addEventListener('click', onPagerClick);
    return a;
  }

  function onPagerClick(e) {
    e.preventDefault();
    history.pushState({}, '', this.getAttribute('href'));
    renderPage();
    var head = root.querySelector('.mw-news__head');
    if (head) head.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function renderPage() {
    var total = allArticles.length;
    var totalPages = Math.max(1, Math.ceil(total / perPage));
    var current = Math.min(currentPage(), totalPages);
    var start = (current - 1) * perPage;
    var items = allArticles.slice(start, start + perPage);
    grid.innerHTML = items.map(cardHtml).join('');
    buildPager(current, totalPages);
  }

  window.addEventListener('popstate', renderPage);

  Promise.all([fetchFeed(blogHandle, 'blog'), fetchFeed(eventHandle, 'event')]).then(function (res) {
    allArticles = res[0].concat(res[1]).sort(function (a, b) {
      return (b.ts || 0) - (a.ts || 0);
    });
    if (status) status.style.display = 'none';
    if (allArticles.length === 0) {
      if (status) {
        status.style.display = '';
        status.textContent = '';
      }
      return;
    }
    renderPage();
  });
});

/* ==============================
  SP：パンくずを最近チェックしたアイテムの直前へ移動
============================== */
// (() => {
//   const mediaQuery = window.matchMedia('(max-width: 749px)');
//   let breadcrumbSection = null;
//   let recentlyViewedSection = null;
//   let originalMarker = null;

//   const initBreadcrumbPosition = () => {
//     const breadcrumb = document.querySelector('.brand-breadcrumb');
//     const recentlyViewedContainer = document.querySelector(
//       '[id^="recently-viewed-container-"]'
//     );

//     if (!breadcrumb || !recentlyViewedContainer) return;

//     breadcrumbSection = breadcrumb.closest('.shopify-section');
//     recentlyViewedSection = recentlyViewedContainer.closest('.shopify-section');

//     if (!breadcrumbSection || !recentlyViewedSection) return;

//     /*
//      * PCへ戻した際に元の位置へ復元するため、
//      * パンくずの元位置に目印を置く
//      */
//     if (!originalMarker) {
//       originalMarker = document.createComment(
//         'brand-breadcrumb-original-position'
//       );

//       breadcrumbSection.parentNode.insertBefore(
//         originalMarker,
//         breadcrumbSection
//       );
//     }

//     updateBreadcrumbPosition();
//   };

//   const updateBreadcrumbPosition = () => {
//     if (
//       !breadcrumbSection ||
//       !recentlyViewedSection ||
//       !originalMarker
//     ) {
//       return;
//     }

//     if (mediaQuery.matches) {
//       /*
//        * スマホ：
//        * 最近チェックしたアイテムの直前へ移動
//        */
//       recentlyViewedSection.parentNode.insertBefore(
//         breadcrumbSection,
//         recentlyViewedSection
//       );
//     } else {
//       /*
//        * PC：
//        * 元の位置へ戻す
//        */
//       originalMarker.parentNode.insertBefore(
//         breadcrumbSection,
//         originalMarker.nextSibling
//       );
//     }
//   };

//   if (document.readyState === 'loading') {
//     document.addEventListener(
//       'DOMContentLoaded',
//       initBreadcrumbPosition
//     );
//   } else {
//     initBreadcrumbPosition();
//   }

//   mediaQuery.addEventListener('change', updateBreadcrumbPosition);
// })();

/* =========================================================
  Staff Start スタッフランキング
  SP時、絞り込みをスタッフ一覧見出しの直下へ移動
========================================================= */
(() => {
  const MOBILE_BREAKPOINT = 768;

  const moveStaffFilter = () => {
    if (window.innerWidth > MOBILE_BREAKPOINT) return;

    const app = document.querySelector(
      '#staffstart-shopify-app-container'
    );

    if (!app) return;

    /* 「絞り込む」ボタンを取得 */
    const filterButton = Array.from(
      app.querySelectorAll('button')
    ).find((button) => {
      return button.textContent.trim() === '絞り込む';
    });

    if (!filterButton) return;

    /*
      貼ってもらったHTMLでは、
      ボタンの親の親が絞り込み全体
    */
    const filterBlock =
      filterButton.parentElement?.parentElement;

    if (!filterBlock) return;

    /* スタッフ一覧見出しを探す */
    const staffHeading = Array.from(
      app.querySelectorAll('h2')
    ).find((heading) => {
      return heading.textContent.trim() === 'スタッフ一覧';
    });

    if (!staffHeading) return;

    /*
      <h2>スタッフ一覧</h2>を含む見出し行
      <div class="sc-xwuxA ..."> を取得
    */
    const staffHeader = staffHeading.closest(
      '.sc-xwuxA'
    );

    if (!staffHeader) return;

    /* すでに移動済みなら何もしない */
    if (staffHeader.nextElementSibling === filterBlock) {
      return;
    }

    /* 見出し行の直後へ、ブロックごと移動 */
    staffHeader.after(filterBlock);

    filterBlock.classList.add(
      'staff-ranking-filter-block'
    );
  };

  const initStaffFilterMove = () => {
    const app = document.querySelector(
      '#staffstart-shopify-app-container'
    );

    if (!app) {
      requestAnimationFrame(initStaffFilterMove);
      return;
    }

    moveStaffFilter();

    const observer = new MutationObserver(() => {
      moveStaffFilter();
    });

    observer.observe(app, {
      childList: true,
      subtree: true,
    });
  };

  initStaffFilterMove();
})();

document.addEventListener('DOMContentLoaded', function () {
  var accordionItems = document.querySelectorAll(
    '.payment-accordion__item'
  );

  accordionItems.forEach(function (item) {
    var button = item.querySelector('.payment-accordion__button');

    button.addEventListener('click', function () {
      var isOpen = item.classList.contains('is-open');

      accordionItems.forEach(function (otherItem) {
        otherItem.classList.remove('is-open');

        var otherButton = otherItem.querySelector(
          '.payment-accordion__button'
        );

        otherButton.setAttribute('aria-expanded', 'false');
      });

      if (!isOpen) {
        item.classList.add('is-open');
        button.setAttribute('aria-expanded', 'true');
      }
    });
  });
});

//ハンバーガーメニューポイント表示
(function () {
  function initDrawerPointify(retryCount) {
    var pointElement = document.querySelector(
      '.brand-drawer-member .gi-pointify-available-point'
    );

    if (!pointElement) return;

    // すでにポイントが表示されていれば何もしない
    if (pointElement.textContent.trim() !== '') return;

    if (
      window.giPointify &&
      window.giPointify.giPointifyView &&
      typeof window.giPointify.giPointifyView.getCustomerAndUpdateView === 'function'
    ) {
      window.giPointify.giPointifyView.getCustomerAndUpdateView();
      return;
    }

    if (retryCount >= 10) return;

    setTimeout(function () {
      initDrawerPointify(retryCount + 1);
    }, 500);
  }

  window.addEventListener('load', function () {
    initDrawerPointify(0);
  });
})();

// レビューページ内リンクズレ
(function () {
  if (window.location.hash !== '#judgeme_product_reviews') return;

  function getHeaderOffset() {
    return window.matchMedia('(max-width: 749px)').matches ? 90 : 140;
  }

  function scrollToReviews() {
    var target = document.getElementById('judgeme_product_reviews');
    if (!target) return false;

    var top =
      target.getBoundingClientRect().top +
      window.pageYOffset -
      getHeaderOffset();

    window.scrollTo({
      top: top,
      behavior: 'auto'
    });

    return true;
  }

  function initReviewAnchorScroll() {
    var attempts = 0;
    var stableCount = 0;
    var lastTop = null;

    var timer = setInterval(function () {
      var target = document.getElementById('judgeme_product_reviews');

      if (!target) {
        attempts++;

        if (attempts >= 20) {
          clearInterval(timer);
        }

        return;
      }

      var currentTop =
        target.getBoundingClientRect().top +
        window.pageYOffset;

      if (lastTop !== null && Math.abs(currentTop - lastTop) < 2) {
        stableCount++;
      } else {
        stableCount = 0;
        scrollToReviews();
      }

      lastTop = currentTop;
      attempts++;

      if (stableCount >= 3 || attempts >= 20) {
        scrollToReviews();
        clearInterval(timer);
      }
    }, 300);
  }

  window.addEventListener('load', function () {
    scrollToReviews();
    initReviewAnchorScroll();
  });
})();